import { render, staticRenderFns } from "./AssetPage.vue?vue&type=template&id=2a276332&scoped=true&"
import script from "./AssetPage.vue?vue&type=script&lang=js&"
export * from "./AssetPage.vue?vue&type=script&lang=js&"
import style0 from "./AssetPage.vue?vue&type=style&index=0&id=2a276332&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a276332",
  null
  
)

export default component.exports